import { useQuery } from "@apollo/client";
import { graphql } from "gql/apollo";

export const NearbyAssetCountQuery = graphql(/* GraphQL */ `
	query nearbyAssetCount($params: GetIncidentCountsParams!) {
		getIncidentCounts(params: $params) {
			nearby_asset_count
		}
	}
`);

export const useNearbyAssetCount = (
	incidentId: string,
	skip: boolean = false
) => {
	const { data, loading } = useQuery(NearbyAssetCountQuery, {
		variables: {
			params: {
				_id: incidentId,
			},
		},
		skip,
	});

	return {
		nearbyAssetCount: data?.getIncidentCounts.nearby_asset_count,
		loading,
	};
};
